import React, {useState, useEffect, useRef} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const PayrollCostallicationListComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [payrollcostallications, setPayrollCostallications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [formData, setFormData] = useState({});
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      apiCall('get', '/api/v2/cost-allocation/summary/payroll/' + id)
        .then(response => {
          const items = Array.isArray(response?.data?.data) ? response.data.data : [];
          setTotalRecords(items.length);
          setPayrollCostallications(items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const formatCurrency = (currency, amount) => {
    if (window.App && typeof window.App.currencyFormatter === 'function') {
      return window.App.currencyFormatter(currency || formData.currency, Number(amount || 0));
    }
    return <>{Number(amount || 0)}&nbsp;{currency || formData.currency}</>;
  };

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
  //                 tooltip={t('edit')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if(entity === 'payroll') {
  //                     history.push('/inventory/tmp/update/' + rowData.id)
  //                   }
  //                 }}/>
  //       }
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-trash" className="p-button-danger"
  //                 tooltip={t('delete')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if (window.confirm('A törlés megerősítésére van szükség!')) {
  //                     setLoading(true);
  //                     apiCall('delete', '/api/v2/tmp/' + rowData.id)
  //                       .then(response => {
  //                         window.App.toastShow('success', 'Sikeres törlés!');
  //                         window.App.setState({rerenderTmpList: Math.random()})
  //                       })
  //                       .catch(error => {
  //                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //                       })
  //                       .finally(() => {
  //                         setLoading(false);
  //                       })
  //                   }
  //                 }}
  //         />
  //       }
  //     </React.Fragment>
  //   );
  // }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderPayrollCostallocationList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={payrollcostallications} first={lazyParams.first} totalRecords={totalRecords}
                 className="p-datatable-sm"
                 loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="cost_type" header={t('columnCostType')}></Column>
        <Column field="cost_center" header={t('columnCostCenter')}></Column>
        <Column field="cost_source" header={t('columnCostSource')} body={(rowData) => (
          rowData?.cost_source ? t(`costSource${rowData.cost_source}`) : ''
        )}></Column>
        <Column field="currency" header={t('columnCurrency')}></Column>
        <Column field="amount" header={t('columnAmount')} body={(rowData) => formatCurrency(rowData.currency, rowData.amount)} ></Column>




        {/* <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column> */}
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(PayrollCostallicationListComponent);
